'use strict'

module.exports = require('./lib').default



//////////////////
// WEBPACK FOOTER
// ./node_modules/private-ip/index.js
// module id = 1042
// module chunks = 33